<template>
  <div class="table-component">
    <artisio-table selectable ref="invoiceTable" :pagination="tableData.pagination" :sort="tableData.ordering"
                   :items="items" :fields="tableFields" :checkboxes="true" :extra-data="extraData"
                   :search="tableData.search" :enable-simple-search="false" requires-min-height
                   :index="false" :busy="loading" :show-toggle-columns="true"
                   @paramsChanged="getTableData" @update-toggle-columns="updateToggleColumns"
                   @on-column-save="updateToggleColumns">
      <template slot="cell(created_at)" slot-scope="{item}">
        {{ item.created_at | toDate }} by {{ item.created_by.display_name }}
      </template>
      <template slot="cell(items_count)" slot-scope="{item}">
        {{ item.return_note_inventories.length }}
      </template>
      <template slot="cell(is_collected_by_third_party)" slot-scope="{item}">
        <div v-if="item.is_collected_by_third_party">
          <span class="badge bg-success text-white" v-if="item.is_collected_by_third_party">{{ $t('Yes') }}</span>
          - {{ item.collector }}
        </div>
        <div v-else>
          <span class="badge bg-danger text-white">{{ $t('No') }}</span>
        </div>
      </template>
      <template slot="cell(status)" slot-scope="{item}">
        <span v-if="item.contract_status" v-as-status="item.contract_status">
          {{ item.contract_status | removeUnderscores | toUpperCaseEveryWord }}
        </span>
        <span v-as-status="item.contract_status" v-else>{{ $t('N/A') }}</span>
      </template>
      <template slot="cell(actions)" slot-scope="{item}">
        <b-dropdown right class="text-white" variant="primary" no-caret size="sm">
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v" class="icon"/>
          </template>
          <b-dd-item @click="onViewContractClick(item)" v-permission="'change_receipt'">
            <font-awesome-icon icon="file-invoice" style="font-size: .9em" class="mr-1"/>
            {{ $t('View Return Note') }}
          </b-dd-item>
        </b-dropdown>
      </template>
    </artisio-table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapState, mapActions} = createNamespacedHelpers('returnNotes');
  const {mapState: receiptsMapState} = createNamespacedHelpers('receipts');
  const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');

  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import _ from "lodash";
  import {RETURN_NOTES_TABLE_NAME, SOURCE_RETURN_NOTES_TABLE} from "@/modules/constants";

  export default {
    name: "ReturnNotesTable",
    components: {ArtisioTable},
    props: {
      hideActions: {
        type: Array,
        default: () => []
      },
      excludeColumns: {
        type: Array,
        default: () => []
      },
    },
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
        loading: state => state.tableData[state.tableSource].loading,
        items: state => state.tableData[state.tableSource].rows,
        toggleColumns: state => state.tableData[state.tableSource].toggleColumns,
        tableSource: state => state.tableSource
      }),
      ...receiptsMapState({
        receipt: state => state.view.currentReceipt,
      }),
      tableFields() {
        return _.cloneDeep(this.toggleColumns.fields).filter(field => !this.excludeColumns.includes(field.key) && field.isVisible)
      },
      extraData() {
        return {
          ...this.toggleColumns,
          excludeColumns: this.excludeColumns,
          tableName: `${RETURN_NOTES_TABLE_NAME}.${this.tableSource}`,
        }
      },
    },
    methods: {
      ...mapActions({
        getTableData: 'getTableData',
        updateToggleColumns: 'updateToggleColumns',
      }),
      ...mapActionsGlobal([
        'showGeneralContractModal',
        'getGeneralContractModalData',
      ]),
      async onViewContractClick(returnNote) {
        let response = await this.getGeneralContractModalData({
          object: returnNote,
          fileType: 'return_note_contract',
          objectName: 'returnnote',
        });
        if (response.success) {
          this.showGeneralContractModal({
            source: SOURCE_RETURN_NOTES_TABLE,
            object: {...returnNote, customer_uuid: this.receipt.customer_uuid},
            fileType: 'return_note_contract',
            objectName: 'returnnote',
            refreshOnSubmit: true,
            modalTitle: this.$i18n.t("Return Note")
          })
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          }
        }
      },
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
  .artisio-table {
    /deep/ {

    }
  }

</style>
